<template>
  <div
      class="mapgeocoder-control"
      :class="{'p-inputgroup':showSearchInput}"
  >
    <Button
        :class="{'p-button-secondary':!showSearchInput,'p-button-primary':showSearchInput}"
        v-tooltip="$t('Search location')"
        @click="showSearchInput=!showSearchInput"
    >
      <img src="/icons/toolbox/geocode-search.svg" :style="colorToFilter(showSearchInput?'#ffffff':'#000000').filter" style="width:18px;height:18px"/>
    </Button>
    <MapGeocoder
      v-if="showSearchInput"
      :map-controller="mapController"
      :add-on-map="addOnMap"
    />
    <div>

    <span class="p-inputgroup-addon" v-if="showSearchInput && addOnMap">
      <Checkbox v-model="addToMap" :binary="true" input-id="geocodeAddToMap"/>
      <label for="geocodeAddToMap" class="ml-2">{{ $t("Add to map") }}</label>
    </span>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import MapButton from "../MapButton.vue";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import { MapController } from "@/js/Map/map-controller";
import { colorToFilter } from "@/js/plugins/tintFilter";
import Checkbox from "primevue/checkbox";
import AutoComplete from "primevue/autocomplete";
import MapGeocoder from "../MapGeocoder.vue";

export default defineComponent({
  name: "MapGeocoderControl",
  components: {MapGeocoder, MapButton, Button, Dropdown, Checkbox, AutoComplete },
  props: {
    mapController: {
      type: Object as PropType<MapController>,
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    autoAdd: {
      type: Boolean,
      default: false
    },
    addOnMap: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showSearchInput: this.expanded,
      addToMap: this.autoAdd,
      providers: [{ id: 'google', name: 'Google' }, { id: 'mapbox', name: 'Mapbox' }],
      provider: 'google',
      query: '',
      queryResults: [],
    }
  },
  created() {
  },
  methods: {
    colorToFilter
  }
});
</script>
<style lang="scss">
.mapgeocoder-control {
  &.p-inputgroup {
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.1)) !important;
    background-color: #fff;
    border-radius: 10px;
    width: 350px;

    .p-autocomplete-input {
      background-color: #fff !important;


    }
  }

  .p-button {
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.1)) !important;
  }
}

html.dark {

  .mapgeocoder-control.p-inputgroup {
    background-color: #252636;

    .p-autocomplete-input {
      background-color: #252636 !important;

      &.p-inputtext {
        border: #000 !important;
      }
    }
  }
}
</style>
